module.exports = __webpack_public_path__ + "static/media/group-placeholder.f4c438f3.webp";